import DataQueries                   from '../graphql/Queries';
import templateDialogModel, {
  TemplateDialogModel
}                                    from '../schedule/TemplateDialogModel';
import { DefaultSchema, IEditPanelView }             from './SettingsModel';
import { MasterDataSettingsModel }   from './MasterDataSettingsModel';
import TemplateEditPanelHeaderView   from './TemplateEditPanelHeaderView';
import TemplateEditPanelView         from './TemplateEditPanelView';
import TemplateEditorView            from './TemplateEditorView';
import mainPageModel                 from '../main-navigation/MainPageModel';
import { TemplateSort } from '../DataTypes';

export default class TemplatesSettingsModel extends MasterDataSettingsModel {
  constructor() {
    super('Shift Type', 'templates', templateDialogModel);
    this.EditPanelView       = TemplateEditPanelView as IEditPanelView;
    this.EditPanelHeaderView = TemplateEditPanelHeaderView;
    this.EditPanelFormView   = TemplateEditorView;
  }
  protected async _load(filter: {search?: string}, sort?: TemplateSort) {
    const results = (await DataQueries.getTemplates(DefaultSchema + 'archived', filter, sort, this.paging.itemsPerPage, this.paging.currentPage));
    this.setItems(results.data);
    return results;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canAddTemplates;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditTemplates;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canDeleteTemplates;
  }

  getDefaultEditPanelHeaderOptionsItems() {
    let options = super.getDefaultEditPanelHeaderOptionsItems();
    options     = options.map(o => {
      const optionDisabled = o.disabled;
      const option         = {...o};
      if (option.name !== 'Udfs') {
        option.disabled = () => !!((this.editor as TemplateDialogModel).locked || (typeof optionDisabled === 'function' ? optionDisabled() : optionDisabled));
      }
      return option;
    });
    return options;
  }
}
